import styled from 'styled-components/macro';

export const Checkbox = styled.input`
  margin: 0 5px 0 15px !important;
  border-radius: 0;
  stroke: black !important;
  stroke-width: 2px;
`;

export const CheckBoxContainer = styled.td`
  line-height: 1.42857143;
  display: flex;
`;
